import React, { useLayoutEffect } from 'react'
import Grid from '@mui/material/Grid'
import { HeadlineStory, Story } from 'pages/dashboard/CaStories'

const HomepageStories = ({ stories, setHomePageStoriesIsLoaded, aol, isLogged }) => {
  useLayoutEffect(() => {
    setHomePageStoriesIsLoaded(!!stories)
  }, [stories])

  if (!stories) {
    return null
  }

  stories.sort((uno, dos) => uno.position - dos.position)

  return (
    <Grid container spacing={2} className='bg-page-background' style={{ marginTop: 0 }}>
      <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block' } }} style={{ paddingTop: 0 }}>
        <HeadlineStory {...stories[0]} aol={aol} isLogged={isLogged} />
      </Grid>
      <Grid item xs={12} sx={{ display: { xs: 'block', sm: 'none' } }}>
        <Story {...stories[0]} aol={aol} isLogged={isLogged} />
      </Grid>
      {stories.slice(1, 9).map((story) => (
        <Grid key={story.id} item xs={12} sm={6} md={4} lg={4}>
          <Story {...story} aol={aol} isLogged={isLogged} />
        </Grid>
      ))}
      {stories.length > 9 && (
        <Grid key={stories[9].id} item xs={12} sm={6} md={4} lg={4} sx={{ display: { xs: 'block', sm: 'none', md: 'block' } }}>
          <Story {...stories[9]} aol={aol} isLogged={isLogged} />
        </Grid>
      )}
    </Grid>
  )
}

export default HomepageStories
